import { useRef, useMemo, useEffect } from "react";
const useIntersectionObserver = (callback, ref, options) => {
  const callbackRef = useRef(callback);
  const observer = useRef(null);
  useMemo(() => {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(() => {
    const item = ref == null ? void 0 : ref.current;
    if (!item) {
      return;
    }
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      return callbackRef.current(
        { isIntersecting: true },
        {}
      );
    }
    const unobserve = () => {
      var _a;
      (_a = observer == null ? void 0 : observer.current) == null ? void 0 : _a.disconnect();
      observer.current = null;
    };
    if (observer == null ? void 0 : observer.current) {
      unobserve();
    }
    if (item) {
      observer.current = new IntersectionObserver(
        ([entry], currentObserver) => callbackRef.current(entry, currentObserver),
        options
      );
      observer.current.observe(item);
    }
    return () => unobserve();
  }, [ref, options]);
};
export {
  useIntersectionObserver as u
};
//# sourceMappingURL=useIntersectionObserver.DFMFKeB4.mjs.map
